import { HttpStatusCode } from "../lib/HttpStatusCode";
import { SecKy } from "../lib/SecKy";

const endpoint = "/api/comms";
function makeQuery(page, size, dateFrom, dateTo, search, dateFilter, status, sendStatus, hotelCode) {
  var query = `${endpoint}?page=${page || 1}&size=${size || 50}`;
  if (dateFrom)
    query += '&dateFrom=' + dateFrom;
  
  if (dateTo)
    query += '&dateTo=' + dateTo;

  if (search)
    query += '&search=' + search;
  
  if (dateFilter)
    query += '&dateFilter=' + dateFilter;
  
  if (status)
    query += '&status=' + status;
  
  if (sendStatus)
    query += '&sendStatus=' + sendStatus;
  
  if (hotelCode)
    query += '&hotelCode=' + hotelCode;

  return query;
}

function getDefaultState() {
  return {
    count: 0,
    data: []
  };
}

const state = getDefaultState();

const actions = {
  reset({ commit }) {
    commit('mReset');
  },

  
  async getComms({ commit, rootState, dispatch }, [page, size, dateFrom, dateTo, search, dateFilter, status, sendStatus, hotelCode, tillEnd] ) {
    
    let query = makeQuery(page, size, dateFrom, dateTo, search, dateFilter, status, sendStatus, hotelCode);
    
    var result = await SecKy.get(query);
    if (!result.success && result.httpStatusCode == HttpStatusCode.UNAUTHORIZED){
        await dispatch("user/reapplyToken", null, { root: true });
        if (!rootState.user.token) {
            console.log(result.error);
            return;
        }
        result = await SecKy.get(query);
    }

    console.log('load');
    if (tillEnd) {
      let i = 2;
      while (result.payload.count > result.payload.data.length) {
        const comms = await SecKy.get(makeQuery(i, size, dateFrom, dateTo, search, dateFilter, status, sendStatus, hotelCode));
        result.payload.data = result.payload.data.concat(comms.payload.data);
      }
    }

    console.log(result.payload);
    
    result.payload.data = result.payload.data.map(x => {
      x.reservation.reservationValues = x.reservation.reservationValues.map(y => {
        y.key = y.variable.variable;
        x[y.variable.variable] = y.value
        return y;
      })

      x.LOS = dateDiffInDays(x.reservation.arrivalDate, x.reservation.departureDate);
      return x;
    });

    commit("mSet", result.payload);
  }
};


const mutations = {
  mReset(state) {
    Object.assign(state, getDefaultState());
  },
  mSet(state, payload) {
    console.log(state);

    state.count = payload.count;
    state.data = payload.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

function dateDiffInDays(a, b) {
  if (typeof a === 'string')
    a = new Date(a); 
  if (typeof b === 'string')
    b = new Date(b); 
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}